import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Divider,
  Fieldset,
  Grid,
  Group,
  ScrollArea,
  Table,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconArrowBack, IconCheck } from "@tabler/icons-react";
import cx from "clsx";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { getValueById } from "../../_base/helper/FunctionHelper";
import {
  formatDateTime,
  formatDateTransfer,
} from "../../common/FormatDate/FormatDate";
import { sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import classes from "../../Styles/TableScrollArea.module.css";
import ListProductDetail from "./ListProductDetail";
import { normalizeZnsPhoneNumber } from "../../service/znsService";
export interface UpdateStatusDetails {
  headerId: number;
  testDifficulty: string | null;
  testPoint: number | null;
  updateStatusTblTestingTechniqueHeaderDetailCommandModels: UpdateStatusTblTestingTechniqueHeaderDetailCommandModel[];
}

interface UpdateStatusTblTestingTechniqueHeaderDetailCommandModel {
  id: number;
  testDifficulty: string | null;
  testingStatus: string | null;
  noteByEmployee: string | null;
}

const ModalUpdateTestingTechnique = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const id = location?.state && location.state.id;
  const dataStatusOption = location?.state && location.state.dataStatusOption;

  const entity = {
    testingTechniqueHeaderId: Number(id),
    processingDate: null,
    priorityId: null,
    difficultyLevelId: null,
    note: null,
    responsibleEmployeeId: null,
    assignToTblTestingTechniqueHeaderCommandModels: null,
  };

  const entitySubmit = {
    headerId: 0,
    testDifficulty: null,
    testPoint: null,
    updateStatusTblTestingTechniqueHeaderDetailCommandModels: [],
  };
  const form = useForm<any>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    transformValues: (values) => ({
      ...values,
      priorityId: Number(values.priorityId),
      difficultyLevelId: Number(values.difficultyLevelId),
    }),
  });

  const submitFrom = useForm<UpdateStatusDetails>({
    mode: "uncontrolled",
    initialValues: {
      ...entitySubmit,
    },
  });
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [scrolled, setScrolled] = useState(false);

  const [dataDetail, setDataDetail] = useState<any>({});
  const initialScreenHeightRef = useRef<number>(window.innerHeight);
  const boxTopRef = useRef<number>(0);
  const [bottomBoxHeight, setBottomBoxHeight] = useState(0);
  const [datatestDifficultys, setdatatestDifficultys] = useState<any>();
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [dataPNHL, setDataPNHL] = useState<any>({});

  const getWarrantyReceiveTicket = async (sourceCode: string) => {
    if (!sourceCode) return;

    const res = await repositoryMdm.get<MessageResponse<any[]>>(
      `/api/v1/TblWarrantyReceiveTicket/get-list-v2?Skip=0&Take=1&KeySearch=${sourceCode}`,
    );

    if (res && res?.success) {
      setDataPNHL(res.data?.[0]);
    }
  };

  const getDefectiveItemBySerial = async (serial: string) => {
    if (!serial) return;

    const res = await repositoryDelivery.get<MessageResponse<any[]>>(
      `/api/v1/DefectiveItemsList/get-list?Skip=0&Take=1&ItemType=1&KeySearch=${serial}`,
    );

    if (res && res?.success) {
      await getWarrantyReceiveTicket(res.data?.[0]?.receiveTicketCode);
    }
  };

  const getDetailProduct = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblTestingTechniqueHeader/get-detail-v2?id=${id}`,
    );

    if (res && res?.success) {
      const dataApi = res.data;
      setDataDetail(dataApi);
      setdatatestDifficultys(dataApi?.testDifficulty);
      form.setValues(dataApi);
      submitFrom.setValues((prev) => ({
        headerId: dataApi?.id,
        testDifficulty: dataApi?.testDifficulty ?? "DON_GIAN",
        updateStatusTblTestingTechniqueHeaderDetailCommandModels:
          dataApi?.tblTestingTechniqueDetailModels?.map((item: any) => ({
            id: item?.id,
            testDifficulty: item?.testDifficulty,
            testingStatus: item?.testingStatus,
            noteByEmployee: item?.noteByEmployee,
          })),
      }));

      if (dataApi?.sourceType === "NHAP_KHO_BH_NCC") {
        await getDefectiveItemBySerial(
          dataApi?.tblTestingTechniqueDetailModels?.[0]?.serial,
        );
      }
    }
  };

  const handleSendZns = async () => {
    const phone = normalizeZnsPhoneNumber(dataPNHL?.custPhone);

    if (!phone || !dataPNHL?.requestNum) return;

    try {
      const sendZns = await repositoryPos.post<
        MessageResponse<any> & { status?: string | number | null }
      >("/api/v1/Zns/send", {
        from: "2761260980408892837",
        to: phone,
        template_id: "483804",
        template_data: {
          branch_name: dataPNHL?.branchName,
          so_phieu: dataPNHL?.requestNum,
          customer_name: dataPNHL.custMeeting,
        },
        client_req_id: String(dataPNHL.requestNum) + `${Date.now()}`,
      });

      if (sendZns && String(sendZns.status) === "1") {
        NotificationExtension.Success("Cập nhật kiểm tra thành công");
      }
    } catch (error) {
      console.error("Error sending Zns:", error);
    }
  };

  const handleUpdate = async (dataSubmit: any) => {
    if (
      dataDetail?.isSelectWithAssign &&
      location?.state?.testingStatusBHNCC === "TEST_OK" &&
      location?.state?.testingStatusBHNCC === "TEST_LOI"
    ) {
      handleAssignEmployee({
        ...dataSubmit,
        testPoint: dataDetail?.testPoint,
      });
    } else {
      const res = await repositoryMdm.get<MessageResponse<any>>(
        "/api/v1/TechnicalTestLevel/get-list?Skip=0&Take=100",
      );

      if (res && res.success) {
        const data = res?.data?.find(
          (i: any) => i.code === dataSubmit?.testDifficulty,
        )?.point;

        if (!data && Number(data) !== 0) {
          NotificationExtension.Fails(
            "Có lỗi xảy ra trong quá trình cập nhật vui lòng thử lại sau ít phút !",
          );
          console.log("Không tìm thấy điểm của mức độ test !");
        } else {
          const dataProps = {
            ...dataSubmit,
            testPoint: data,
          };

          handleAssignEmployee(dataProps);
        }
      } else {
        NotificationExtension.Fails(
          "Có lỗi xảy ra trong quá trình cập nhật vui lòng thử lại sau ít phút !",
        );
        console.log("API lỏ r báo BE đi cà =))");
      }
    }
  };

  // console.log("form", form.getValues());
  const handleAssignEmployee = async (dataSubmit: any) => {
    if (dataSubmit.testDifficulty == null) {
      return NotificationExtension.Fails("Vui lòng chọn mức độ test của phiếu");
    }
    const url =
      location?.state?.testingStatusBHNCC === "TEST_OK" ||
      location?.state?.testingStatusBHNCC === "TEST_LOI"
        ? "/api/v1/TblTestingTechniqueHeader/update-status-detail-for-manager"
        : "/api/v1/TblTestingTechniqueHeader/update-status-detail";
    open();
    try {
      const response = await repositoryDelivery.post<
        MessageResponse<UpdateStatusDetails>
      >(url, dataSubmit);
      if (response?.success) {
        NotificationExtension.Success("Cập nhật kiểm tra thành công");

        // Chỉ gửi Zns khi tồn tại ít nhất 1 sản phẩm có trạng thái kiểm tra là Test OK
        const hasTestOk =
          dataSubmit?.updateStatusTblTestingTechniqueHeaderDetailCommandModels?.some(
            (item: any) => item?.testingStatus === "TEST_OK",
          );

        if (
          hasTestOk &&
          dataDetail?.sourceType === "NHAP_KHO_BH_NCC" &&
          ["BH khách lẻ", "BH hỗ trợ", "BH dịch vụ"].includes(
            dataPNHL?.customerGroup.trim(),
          ) &&
          getValueById(
            String(dataPNHL?.branchId),
            dataBranch,
            "companyCode",
          ) !== "DVT"
        ) {
          // await handleSendZns();
        }

        modals.closeAll();
        setTimeout(() => {
          navigate("/testing/testing-technique");
        }, 1500);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      close();
    }
  };

  const ViewtechnicalRequired = (value: number) => {
    let result = "";
    switch (value) {
      case 0:
        result = "Không";
        break;
      case 1:
        result = "Lắp máy(mới)";
        break;
      case 2:
        result = "Kiểm tra(mới)";
        break;
      case 3:
        result = "Lắp ráp(mới)+kiểm tra(mới)";
        break;
      default:
        result = "Không yêu cầu";
        break;
    }
    return result;
  };

  const getDataBranchSelect = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const result = res.data
        ?.filter((i: any) => i.name && i.id)
        ?.map((i: any) => ({
          id: String(i.id),
          name: String(i.name),
          companyCode: String(i.companyCode),
        }));

      setDataBranch(result);
    }
  };

  useEffect(() => {
    if (id) getDetailProduct();
  }, [id]);

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      if (boxTopRef.current) {
        const boxTopHeight = boxTopRef.current;
        const totalHeight = window.innerHeight;
        const calculatedBottomHeight = totalHeight - boxTopHeight;
        setBottomBoxHeight(calculatedBottomHeight);
      }
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <Box
      component="form"
      mx="auto"
      onSubmit={submitFrom.onSubmit((e) => {
        handleUpdate(e);
      })}
    >
      <Box
        ref={(el) => {
          if (el) boxTopRef.current = el.offsetHeight;
        }}
      >
        <Group
          justify="end"
          mt="md"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="red"
            loading={visible}
            onClick={() => {
              navigate("/testing/testing-technique");
            }}
            leftSection={!visible ? <IconArrowBack size={18} /> : undefined}
          >
            Quay lại
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Cập nhật
          </Button>
        </Group>

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 12, lg: 5 }} mt={0} pt={0} mb={10}>
            <Fieldset legend={<Badge>Thông tin phân công</Badge>}>
              <Grid mt={"10px"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6 }} mb={0}>
                  <TextInput
                    readOnly
                    label="Mã kiểm tra"
                    value={form.getValues()?.code}
                  ></TextInput>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                  <TextInput
                    readOnly
                    label="Ngày phân công"
                    value={formatDateTransfer(form.getValues()?.processingDate)}
                  ></TextInput>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                  <TextInput
                    readOnly
                    label="Yêu cầu dịch vụ"
                    // value={ViewtechnicalRequired(
                    //   Number(form.getValues().technicalRequired)
                    // )}
                    value={
                      location?.state.typeSourceType == "DON_HANG"
                        ? ViewtechnicalRequired(
                            Number(form.getValues().technicalRequired),
                          )
                        : "Kiểm tra sản phẩm BH NCC"
                    }
                  ></TextInput>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                  <TextInput
                    readOnly
                    label="Nội dung phân công"
                    value={form.getValues().note}
                  ></TextInput>
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 12, lg: 7 }} mt={0} pt={0} mb={10}>
            <Fieldset
              legend={<Badge color="orange">Thông tin kỹ thuật</Badge>}
              h="calc(100% - 14px)"
            >
              <ScrollArea
                h={150}
                onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                scrollbars="y"
                mt={7.5}
              >
                <Table
                  striped
                  highlightOnHover
                  withTableBorder
                  withColumnBorders
                >
                  <Table.Thead
                    className={cx(classes.header, {
                      [classes.scrolled]: scrolled,
                    })}
                  >
                    <Table.Tr>
                      {/* <Table.Th>Người chịu trách nhiệm</Table.Th> */}
                      <Table.Th>Mã nhân viên</Table.Th>
                      <Table.Th>Tên nhân viên</Table.Th>
                      <Table.Th>Chức danh</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {dataDetail?.tblTestingTechniqueAssignmentModels &&
                      dataDetail?.tblTestingTechniqueAssignmentModels.length >
                        0 &&
                      dataDetail?.tblTestingTechniqueAssignmentModels.map(
                        (emp: any, index: any) => (
                          <Table.Tr key={emp.id}>
                            {/* <Table.Td>
                                <Checkbox
                                  checked={
                                    dataTestingTechnique?.responsibleEmployeeId ===
                                    emp?.emloyeeId
                                  }
                                  readOnly
                                />
                              </Table.Td> */}
                            <Table.Td>{emp.emloyeeCode}</Table.Td>
                            <Table.Td>{emp.emloyeeName}</Table.Td>
                            <Table.Td>{emp.emloyeeRole}</Table.Td>
                          </Table.Tr>
                        ),
                      )}
                  </Table.Tbody>
                </Table>
              </ScrollArea>
            </Fieldset>
          </Grid.Col>
        </Grid>
        <Divider
          label={
            <Badge color="green" size="md">
              {/* {location?.state.typeSourceType == "DON_HANG"
                ? " Thông tin chi tiết đơn hàng"
                : "Thông tin nhập BH NCC"} */}
              {location?.state.typeSourceType == "DON_HANG"
                ? " Thông tin chi tiết đơn hàng"
                : location?.state.typeSourceType == "CHUYEN_DOI_DU_LIEU"
                  ? "Thông tin chuyển đổi dữ liệu"
                  : location?.state.typeSourceType == "NHAP_KHO_BH"
                    ? "Thông tin nhập kho bảo hành"
                    : location?.state.typeSourceType == "NHAP_KHO_BH_NCC"
                      ? "Thông tin nhập kho bảo hành NCC"
                      : location?.state.typeSourceType == "LAP_RAP"
                        ? "Thông tin phiếu lắp ráp"
                        : location?.state.typeSourceType == "KHAC"
                          ? "Thông tin phiếu KTKT thủ công"
                          : ""}
            </Badge>
          }
          labelPosition="center"
        />
        <Grid mt={10} mb={10}>
          {location?.state.typeSourceType == "DON_HANG" ? (
            <>
              <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                <TextInput
                  label="Mã đơn hàng"
                  size="xs"
                  readOnly
                  value={dataDetail?.sourceCode || ""}
                />
              </Grid.Col>

              <Grid.Col span={{ base: 12, md: 6, lg: 2.5 }}>
                <TextInput
                  label="Chi nhánh"
                  size="xs"
                  readOnly
                  value={dataDetail?.branchName || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.5 }}>
                <TextInput
                  label="Kho"
                  size="xs"
                  readOnly
                  // value={dataDetail?.subInvName || ""}
                  value={`${dataDetail?.subInvName ?? ""}` || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.5 }}>
                <TextInput
                  label="Bộ phận giao hàng"
                  size="xs"
                  readOnly
                  value={dataDetail?.actribute4 || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2.5 }}>
                <TextInput
                  label="Tên khách hàng"
                  size="xs"
                  readOnly
                  value={dataDetail?.customerName || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Số điện thoại"
                  size="xs"
                  readOnly
                  value={dataDetail?.customerTelephone || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Trạng thái kiểm tra"
                  size="xs"
                  readOnly
                  value={getValueById(
                    dataDetail?.testingStatus?.toString(),
                    dataStatusOption,
                    "label",
                  )}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Ghi chú"
                  size="xs"
                  readOnly
                  value={dataDetail?.description || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Ghi chú (Nội bộ)"
                  size="xs"
                  readOnly
                  value={dataDetail?.actribute2 || ""}
                />
              </Grid.Col>
            </>
          ) : location?.state.typeSourceType == "CHUYEN_DOI_DU_LIEU" ? (
            <>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Chi nhánh"
                  size="xs"
                  readOnly
                  value={dataDetail?.branchName || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Kho"
                  size="xs"
                  readOnly
                  // value={dataTestingTechnique?.subInvName || ""}
                  value={`${dataDetail?.subInvName ?? ""}` || ""}
                />
              </Grid.Col>
              {/* <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
                <TextInput
                  label="Vị trí trong kho"
                  size="xs"
                  readOnly
                  value={dataDetail?.invPositionName || ""}
                />
              </Grid.Col> */}
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Trạng thái kiểm tra"
                  size="xs"
                  readOnly
                  value={getValueById(
                    dataDetail?.testingStatus?.toString(),
                    dataStatusOption,
                    "label",
                  )}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Ghi chú"
                  size="xs"
                  readOnly
                  value={dataDetail?.description || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Ghi chú (Nội bộ)"
                  size="xs"
                  readOnly
                  value={dataDetail?.actribute2 || ""}
                />
              </Grid.Col>
            </>
          ) : location?.state.typeSourceType === "KHAC" ? (
            <>
              <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                <TextInput
                  label="Mã phiếu"
                  size="xs"
                  readOnly
                  value={dataDetail?.code || ""}
                />
              </Grid.Col>

              <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                <TextInput
                  label="Chi nhánh"
                  size="xs"
                  readOnly
                  value={dataDetail?.branchName || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                <TextInput
                  label="Trạng thái kiểm tra"
                  size="xs"
                  readOnly
                  value={getValueById(
                    dataDetail?.testingStatus?.toString(),
                    dataStatusOption,
                    "label",
                  )}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Ghi chú"
                  size="xs"
                  readOnly
                  value={dataDetail?.description || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Ghi chú (Nội bộ)"
                  size="xs"
                  readOnly
                  value={dataDetail?.actribute2 || ""}
                />
              </Grid.Col>
            </>
          ) : (
            <>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Mã nhập BH NCC"
                  size="xs"
                  readOnly
                  value={dataDetail?.sourceCode || ""}
                />
              </Grid.Col>

              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Chi nhánh"
                  size="xs"
                  readOnly
                  value={dataDetail?.branchName || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Kho"
                  size="xs"
                  readOnly
                  // value={dataDetail?.subInvName || ""}
                  value={`${dataDetail?.subInvName ?? ""}` || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <TextInput
                  label="Bộ phận giao hàng"
                  size="xs"
                  readOnly
                  value={dataDetail?.actribute4 || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                <TextInput
                  label="Trạng thái kiểm tra"
                  size="xs"
                  readOnly
                  value={getValueById(
                    dataDetail?.testingStatus?.toString(),
                    dataStatusOption,
                    "label",
                  )}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                <TextInput
                  label="Ghi chú"
                  size="xs"
                  readOnly
                  value={dataDetail?.description || ""}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                <TextInput
                  label="Ghi chú (Nội bộ)"
                  size="xs"
                  readOnly
                  value={dataDetail?.actribute2 || ""}
                />
              </Grid.Col>
            </>
          )}
        </Grid>
      </Box>
      <ListProductDetail
        typeSourceType={location?.state.typeSourceType}
        form={submitFrom}
        datatestDifficultys={datatestDifficultys}
        dataDetail={dataDetail?.tblTestingTechniqueDetailModels}
        isDetail={true}
        showBhmr
        height={bottomBoxHeight - 140}
        isReadOnlyTestDifficulty={
          dataDetail?.isSelectWithAssign === "1" &&
          location?.state?.testingStatusBHNCC !== "TEST_OK" &&
          location?.state?.testingStatusBHNCC !== "TEST_LOI"
        }
      />
    </Box>
  );
};

export default ModalUpdateTestingTechnique;
